<form class="search-products">
  <div class="row no-mobile margin-left-0" *ngIf="showProductOptions">
    <div class="col-lg-3 product-sort">
      <span id="lbl-sort-by" class="headerColor heading">Sort</span>
    </div>
    <div class="col-lg-9 product-filter">
      <span id="lbl-filter" class="headerColor heading">Filter</span>
    </div>
  </div>
  <form>
    <div class="row margin-left-0" *ngIf="showProductOptions">
        <div class="col-lg-3 product-sort controls mg-3">
          <select class="no-mobile"
           placeholder="Sort By"
           name="sortBy"
           id="sort-by"
           [(ngModel)]="productFilterOptions.sortBy"
           (change)="onProductSorts()"
           >
            <option id="sort-item" value="itemId"> Item # </option>
            <option id="sort-ndc" value="ndc"> NDC </option>
            <option id="sort-brand" value="brandName"> Brand Name </option>
            <option id="sort-description" value="description"> Product Description </option>
            <option id="sort-size" value="labelSize"> Size </option>
          </select>
          <select 
            class="no-mobile"
            placeholder="Direction" 
            name="direction" 
            id="sort-direction"
            [(ngModel)]="productFilterOptions.direction" 
            (change)="onProductSorts()"
            >
            <option id="sort-asc" value="asc"> A-Z </option>
            <option id="sort-des" value="des"> Z-A </option>
          </select>
        </div>
        <div class="col-lg-8 product-filter">
          <select 
            class="no-mobile mg-3" 
            placeholder="Strength" 
            name="strength" 
            id="filter-strength"
            [(ngModel)]="filters.strength.selected" 
            (change)="onProductFilter()"
            >
            <option id="filter-strength-0" value="">Strength</option>
            <option id="filter-strength-all" value="all">All</option>
            <option 
              *ngFor="let strength of filters.strength.values; let i = index" 
              id="filter-strength-{{i+1}}"
              [ngValue]="strength" 
              [disabled]="!disableFilter('strength', strength)"
              >
              {{ strength }}
            </option>
          </select>
          <select 
            class="no-mobile" 
            placeholder="Size/Count" 
            name="sizeCount" 
            id="filter-size-count"
            [(ngModel)]="filters.size.selected" 
            (change)="onProductFilter()"
            >
            <option id="filter-size-count-0" value="">Size/Count</option>
            <option id="filter-size-count-all" value="all">All</option>
            <option 
              *ngFor="let size of filters.size.values; let i = index" 
              [ngValue]="size"
              id="filter-size-count-{{i+1}}" 
              [disabled]="!disableFilter('labelSize', size)"
              >
              {{ size }}
            </option>
          </select>
          <select *ngIf = "!isFormHide"
            class="no-mobile" 
            placeholder="Form" 
            name="productForm" 
            id="filter-form"
            [(ngModel)]="filters.form.selected" 
            (change)="onProductFilter()"
            >
            <option id="filter-form-0" value="">Form</option>
            <option id="filter-form-all" value="all">All</option>
            <option 
              *ngFor="let form of filters.form.values; let i = index" 
              [ngValue]="form" 
              id="filter-form-{{i+1}}"
              [disabled]="!disableFilter('form', form)"
              >
              {{ form }}
            </option>
          </select>
          <select 
            class="no-mobile" 
            placeholder="AccountType" 
            name="productAccount" 
            id="filter-accountType"
            [(ngModel)]="filters.accountType.selected"
            (change)="onProductFilter()"
            >
            <option id="sort-majorRugby" value=""> Major/Rugby</option>
            <option id="sort-major" value="M"> Major</option>
            <option id="sort-rugby" value="R"> Rugby </option>
          </select>
          <button 
            mat-raised-button class="no-mobile" 
            color="primary" 
            id="btn-clear-filters"
            (click)="onClearFilterClick()" 
            *ngIf="filters.config.applied"
            >
            Clear Filters
          </button>
        </div>
    </div>
   
  </form>
  <par-paginator class="no-mobile" 
    [pageSizes]="productFilterOptions.pageSizes" 
    [dataSource]="products"
    [currentPage]="productFilterOptions.selectedPage" 
    [currentPageSize]="productFilterOptions.selectedPageSize"
    [fullCatalogSearch]="isFullCatalogSearch" 
    [productSearchPageVO]="productSearchPageVO"
    (change)="onProductPageChange($event)" 
    *ngIf="showPagination">
  </par-paginator>
  <div class="clear"></div>
  <div *ngIf="noProductsFound && productsLoaded" class="no-products">
    <p id="no-products-found-message">We did not find any products that matched your search criteria. Please retry your
      search using any of the following:</p>
    <ul>
      <li>Item Number</li>
      <li>NDC Number</li>
      <li>UPC</li>
      <li>Brand Name</li>
      <li>Generic Name (Description)</li>
    </ul>
    <p id="no-products-found-message"> Still not finding what you're looking for? View a full catalog <b>
      <a   (click)="downloadFile()"
      >here</a></b> to utilize the sort and filter functions, or contact your Sales
      Representative at {{ footerData.InquiryNumber }}.</p>
  </div>
  <mat-card 
    *ngFor="
      let product of pagedProductList;
      let i = index" 
    class="search-result-container"
    >
    <!-- [ngClass]="{ updating: product.cartQuantity > 0 && productsOnAddToCart }" -->
    <mat-card-content>
      <mat-spinner diameter="30" *ngIf="detailsLoading" class="order-loading-spinner"></mat-spinner>
      <div class="search-result-div no-mobile">
        <div class="search-result-attributes-div-img">
          <div class="product-image-wrapper">
            <img id="img-{{i+1}}" [src]="product.imgData" class="product-image" />
          </div>
        </div>

        <div class="search-result-attributes-div-details">
          <div class="product-title">
            <a
              class="product-alt"
              id="product-description-{{i+1}}"
              routerLink="/product/details/{{ product.itemId }}"
            >
              <span>{{ product.description }}</span>
            </a>
            </div>
          <div class='display-row'>
            <div class="search-result-attributes-div-info">
              <ul class="list-items">
                <li>
                  <label id="lbl-brand-{{i+1}}">Brand Name: </label>
                  <span id="brand-{{i+1}}">{{ product.brandName }}</span>
                </li>
                <li>
                  <label id="lbl-color-shape-{{i+1}}" class="search-result-bold">Color &amp; Shape: </label>
                  <span id="color-shape-{{i+1}}">{{ product.color }} &amp; {{ product.shape }}</span>
                </li>
               
                <li class="legends">
                  <span class="product-alert cold-alert" id="cold-alert-{{i+1}}" *ngIf="product.isColdAlert"></span>
                  <span class="product-alert hazard-alert" id="hazard-alert-{{i+1}}"
                    *ngIf="product.isHazardalert"></span>
                </li>
              </ul>
            </div>
            <div class="search-result-attributes-div-info">
              <ul class="list-items two-cols-list">
                <li>
                  <div class="col">
                    <label id="lbl-item-{{i+1}}">Item #: </label>
                    <span>
                      <a id="item-{{i+1}}" routerLink="/product/details/{{ product.itemId }}"> <span>{{ product.itemId }}
                        </span></a>
                    </span>
                    <br />
                    <label id="lbl-size-{{i+1}}">Size: </label>
                    <span id="size-{{i+1}}">{{ product.labelSize }}</span>
                  </div>

                  <div class="col">
                    <label id="lbl-ndc-{{i+1}}">NDC: </label>
                    <span id="ndc-{{i+1}}">{{ product.ndc }}</span>
                    <br />
                    <label id="lbl-form-{{i+1}}">Form: </label>
                    <span id="form-{{i+1}}">{{ product.form }}</span>
                    <br />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <par-paginator 
    class="no-mobile" 
    [pageSizes]="productFilterOptions.pageSizes" 
    [dataSource]="products"
    [currentPage]="productFilterOptions.selectedPage" 
    [currentPageSize]="productFilterOptions.selectedPageSize"
    [fullCatalogSearch]="isFullCatalogSearch" 
    [productSearchPageVO]="productSearchPageVO"
    (change)="onProductPageChange($event)" 
    *ngIf="showPagination">
  </par-paginator>
 
  <div class="clear"></div>
  <div class="paginate-action-button mobile-only" *ngIf="!mobileSearchTrigger">
    <button 
      mat-raised-button color="accent" 
      id="btn-previous" 
      *ngIf="productFilterOptions.selectedPage > 1"
      class="previous" 
    >
      Previous 10
    </button>
    <button 
    mat-raised-button color="accent" 
    id="btn-next" 
    *ngIf="
        productFilterOptions.totalPages > productFilterOptions.selectedPage " 
      class="next" 
      >
      Load Next 10
    </button>
  </div>
  
</form>